import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideoutTopBar, ModalSlideoutTopBarDefaultActions, } from '@juvare/common-web-ui/ModalSlideout';
import { Box } from '@mui/material';
import React from 'react';
export const AccountBadgeSlideoutTopBarMenu = ({ menuItems, onClose }) => {
    return (React.createElement(ModalSlideoutTopBar, null,
        React.createElement(Box, { sx: { color: themeColors.icon.link } },
            React.createElement(ModalSlideoutTopBarDefaultActions, { onClose: () => onClose(false), menuItems: menuItems }))));
};
